import type { Direction, Language } from "./finance.ts";

export type CategoryKind = "income" | "cost";

export type FinanceCategory = {
  slug: string;
  kind: CategoryKind;
  nameId: string;
  nameEn: string;
  color: string;
  displayOrder: number;
  active: boolean;
  system: boolean;
  parentSlug?: string;
};

/** The sole technical category. Business categories must be created by Owner. */
export const uncategorizedCategory: FinanceCategory = {
  slug: "uncategorized",
  kind: "income",
  nameId: "Belum Dikategorikan",
  nameEn: "Uncategorized",
  color: "#94a3b8",
  displayOrder: 9999,
  active: true,
  system: true,
};

export const defaultCategories: FinanceCategory[] = [uncategorizedCategory];

export function categoryName(category: string, language: Language, categories: FinanceCategory[] = defaultCategories) {
  const found = categories.find((candidate) => candidate.slug === category);
  if (found) return language === "id" ? found.nameId : found.nameEn;
  return category === "uncategorized"
    ? language === "id" ? "Belum Dikategorikan" : "Uncategorized"
    : category;
}

export function categoriesForDirection(categories: FinanceCategory[], direction: Direction) {
  const kind: CategoryKind | null = direction === "CREDIT" ? "income" : direction === "DEBIT" ? "cost" : null;
  if (!kind) return [];
  return categories
    .filter((category) => category.active && !category.system && !category.parentSlug && category.kind === kind)
    .sort((a, b) => a.displayOrder - b.displayOrder || a.nameId.localeCompare(b.nameId));
}

export function subcategoriesFor(categories: FinanceCategory[], parent: string) {
  return categories.filter((category) => category.parentSlug === parent && category.active)
    .sort((a, b) => a.displayOrder - b.displayOrder || a.nameId.localeCompare(b.nameId));
}

export function categoryColor(category: string, categories: FinanceCategory[]) {
  return categories.find((candidate) => candidate.slug === category)?.color || uncategorizedCategory.color;
}
